import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c43a83a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo-container" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 2,
  class: "clinic-default"
}
const _hoisted_4 = {
  key: 0,
  class: "telehealth-rondel",
  alt: "Telehealth Available"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "telehealth-inner" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-video-2" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrgImage = _resolveComponent("OrgImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "clinic-roundel",
      style: _normalizeStyle($options.outerCircleStyle)
    }, [
      _createElementVNode("div", {
        class: "logo-image",
        style: _normalizeStyle($options.innerCircleStyle)
      }, [
        ($props.orgLog && $options.hasOrgAsset)
          ? (_openBlock(), _createBlock(_component_OrgImage, {
              key: 0,
              "asset-type": _ctx.ORG_ASSET_TYPE.LOGO,
              "image-width": "100%",
              "image-height": "100%"
            }, null, 8, ["asset-type"]))
          : ($props.clinic && $options.clinicHasIcon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: $options.fullIconPath,
                class: "logo-image",
                alt: $props.clinic.name
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("i", {
                  class: _normalizeClass($options.brandIcon),
                  style: _normalizeStyle($options.iconStyle)
                }, null, 6)
              ]))
      ], 4)
    ], 4),
    (($props.clinic && $props.clinic.telehealthEnabled))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}